import React, { useState, useEffect, useRef } from "react";
import { RxCross2 } from "react-icons/rx";
import appLogo from "../assets/img/app_logo.png";
import Navigation from "./OffCanvasRightComponents/Navigation";
import { MdPermMedia } from "react-icons/md";
// import { FaUserLock } from "react-icons/fa6";
import Person from "./Person";

export default function OffCanvasRight({
  setDisplayOffCanvasRight,
  displayOffCanvasRight,
  destinataire,
  allMessages,
}) {
  const [displayTabContent, setDisplayTabContent] = useState(false);
  const boxRefOffCanvasRight = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxRefOffCanvasRight.current &&
        !boxRefOffCanvasRight.current.contains(event.target)
      ) {
        setDisplayOffCanvasRight(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div
        ref={boxRefOffCanvasRight}
        className={`tyn-chat-content-aside ${
          displayOffCanvasRight
            ? "show-aside animate__fadeInRightBig animate__animated"
            : ""
        }`}
        id="tynChatAside"
        data-simplebar
      >
        <div className="simplebar-wrapper" style={{ margin: 0 }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div
              className="simplebar-offset"
              style={{ right: "0px", bottom: "0px" }}
            >
              <div
                className="simplebar-content-wrapper"
                tabIndex="0"
                role="region"
                aria-label="scrollable content"
                style={{ height: "100%", overflowY: "auto" }}
              >
                <div className="simplebar-content" style={{ padding: "0px" }}>
                  <div className="tyn-chat-cover d-flex justify-content-center mt-3">
                    <img
                      src={appLogo}
                      alt="app_logo"
                      className="animate__animated animate__pulse animate__infinite my-tyn-logo"
                      style={{ height: "248px", width: "260px" }}
                    />
                  </div>

                  <div className="tyn-media-group tyn-media-vr tyn-media-center mt-n4">
                    <div className="tyn-media tyn-size-xl border border-2 border-white">
                      <Person
                        person={{
                          image: destinataire.userImage,
                          nom: destinataire.nom,
                          prenom: destinataire.prenom,
                          colors: destinataire.color,
                          userId: destinataire.userId,
                        }}
                      />
                    </div>
                    <div className="tyn-media-col">
                      <div className="tyn-media-row">
                        <h6 className="name">
                          {destinataire.prenom + " " + destinataire.nom}
                        </h6>
                      </div>
                      <div className="tyn-media-row has-dot-sap">
                        <span className="meta">{destinataire.poste}</span>
                      </div>
                    </div>
                  </div>

                  <div className="tyn-aside-row">
                    <ul className="nav nav-btns nav-btns-stretch nav-btns-light">
                      {/* <li className="nav-item">
                        <button
                          className="nav-link js-chat-mute-toggle tyn-chat-mute"
                          type="button"
                          onClick={() =>
                            alert("Une personne devra quitter la room.")
                          }
                        >
                          <span className="icon unmuted-icon">
                            <FaUserLock />
                          </span>
                          <span className="unmuted-icon">Bloquer</span>
                        </button>
                      </li> */}

                      <li className="nav-item">
                        <button
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#chat-media"
                          type="button"
                          onClick={() =>
                            setDisplayTabContent(!displayTabContent)
                          }
                        >
                          <MdPermMedia />

                          <span>Média</span>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div
                    className={`${
                      displayTabContent
                        ? "tab-content animate__animated animate__slideInUp"
                        : "animate__animated animate__fadeOutDown "
                    }`}
                  >
                    <div
                      className="tab-pane active show"
                      id="chat-media"
                      tabIndex="0"
                    >
                      <Navigation
                        myClassName="py-0"
                        linksNavigates={["Images", "Documents", "Liens"]}
                        details={true}
                        allMessages={allMessages}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className={`btn bg-danger text-white btn-md btn-icon btn-pill btn-white shadow position-absolute ${
            !displayOffCanvasRight ? "d-none" : ""
          }`}
          style={{ top: "27px", left: "-33px" }}
          onClick={() => {
            setDisplayOffCanvasRight(false);
          }}
        >
          <RxCross2 />
        </button>
      </div>
    </>
  );
}
